@if (event) {
  <div class="w-full h-32 h-40 md:h-56 lg:h-96 bg-black rounded-xl lg:rounded-3xl overflow-hidden cursor-pointer relative" (click)="navigateTo(getItemUrl(event))">
    <img [src]="getImage(event.multiMedia[0])"
      alt="{{ event.name }}"
      loading="lazy"
      decoding="async"
      fetchpriority="low"
      width="1536"
      height="864"
      class="w-full h-full object-cover absolute inset-0 rounded-xl lg:rounded-3xl">
    <div class="relative z-10 flex items-center justify-center flex-col h-full gap-[0.5rem] lg:gap-6 py-[1rem] px-6 bg-gradient-to-b from-transparent to-black">
      <h2 class="text-white font-semibold text-2xl md:text-3xl lg:text-4xl text-center">{{ event.name }}</h2>
      <p class="text-white text-base lg:text-xl 2xl:text-2xl">{{ event.geoPositionDTO?.location?.comune?.name || ('home.location_unavailable' | translate) }}</p>
    </div>
  </div>
}
